import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Slideshow from '../../containers/slideshow';
import PhotoInfo from '../../containers/photo-info';

const SlideshowBlock = props => <Slideshow {...props} />;
SlideshowBlock.displayName = 'Slideshow';

export default withDynamicComponents({
  componentWhitelist: [
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['photoInfo', 'photoInfo'],
  ],
})(SlideshowBlock);



// WEBPACK FOOTER //
// ./src/blocks/slideshow/index.jsx